import React from 'react'

import { Box, Button, Typography } from '@material-ui/core'
import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import FwdRefNavLink from 'components/FwdRefNavLink'
import { selectClassYearName } from 'store/user'

import Avatar from './Avatar'

/**
 * A Profile preview at the top of the sidebar
 * @param {obj} props
 * @prop {string} highSchoolName
 * @prop {string} classyear
 * @prop {string} firstName
 * @prop {string} lastName
 * @prop {string} nickname
 * @prop {func} onSelectLink
 * @returns ProfilePreview component
 */
const ProfilePreview = ({ highSchoolName, classyear, firstName, lastName, nickname }) => {
  const root = import.meta.env.BASE_URL
  return (
    <List disablePadding>
      <ListItem>
        <ListItemIcon>
          <Avatar size="sm" />
        </ListItemIcon>
        <ListItemText>
          <Typography variant="body1">
            {firstName} {nickname && <React.Fragment>&quot;{nickname}&quot;</React.Fragment>} {lastName}
          </Typography>
          <Box mb={1}>
            <Typography
              variant="body2"
              color="textSecondary"
            >
              {highSchoolName && `${classyear} at ${highSchoolName}`}
            </Typography>
          </Box>
          <Button
            color="primary"
            id="main-nav-view-profile"
            variant="outlined"
            component={FwdRefNavLink}
            to={`${root}/profile`}
          >
            View Profile
          </Button>
        </ListItemText>
      </ListItem>
    </List>
  )
}

ProfilePreview.propTypes = {
  highSchoolName: PropTypes.string,
  classyear: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  nickname: PropTypes.string,
}

export default connect((store) => {
  const user = store.user.record
  const firstName = user.FirstName
  const lastName = user.LastName
  const nickname = user.Nickname
  const highSchoolName = get(user, 'HighSchool.SchoolName')
  const classyear = selectClassYearName(store)

  return {
    highSchoolName,
    classyear,
    firstName,
    lastName,
    nickname,
  }
})(ProfilePreview)
